import { Question } from 'app/question';
import { SurveyId } from '../../survey';

export class SurveyInformation {
  constructor(
    private id: SurveyId,
    public name: string,
    public type: string,
    public startDate: Date,
    public endDate: Date,
    public questionsPerPage: number,
    public reanswerEnabled: boolean,
    public isStarted: boolean,
    public currentPageNumber: number,
    public totalPages: number,
    public sessionStatus: string
  ) { }
}



// WEBPACK FOOTER //
// /dist/src/app/survey/fill-out-the-questionnaire/survey-information.model.ts